import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { buildErrorMessage } from 'utils'
import { workflowKeys } from './workflowKeys'
import { IWorkflow } from 'stores/Workflows/Types'
import { SelectPropertyValue } from 'api/clients/PropertyClient'

interface Props {
  folderId: string
}

export interface CreatePayload {
  config: IWorkflow['configuration']
  property_values: SelectPropertyValue[]
}

export const useCreateWorkflow = ({ folderId }: Props) => {
  return useMutation<{ workflow: IWorkflow }, Error, CreatePayload>(
    workflowKeys.create(folderId),
    async (attributes) => {
      const response = await sendToApi(`/folders/${folderId}/workflow`, {
        method: 'POST',
        body: attributes,
      })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
      return response.data
    },
  )
}
